var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyStudyMaterials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1385_501)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "url(#paint0_linear_1385_501)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.656 16.1383C10.1786 16.0274 9.71748 15.9236 9.25769 15.813C8.50102 15.6307 7.99768 14.9864 8.00001 14.2089C8.002 13.4628 8.51498 12.8226 9.26401 12.646C11.1351 12.2043 13.0075 11.7674 14.8792 11.3284C15.2546 11.2404 15.6329 11.1637 16.0039 11.0598C16.3985 10.9492 16.7769 11.0091 17.1635 11.1011C18.7337 11.4748 20.3059 11.8387 21.8771 12.2074C22.5151 12.3569 23.1551 12.5003 23.7904 12.6612C24.5211 12.8466 25.0148 13.5064 24.9995 14.2515C24.9836 15.0239 24.4676 15.6503 23.7169 15.8174C23.2658 15.9178 22.8166 16.0288 22.3435 16.1404C22.3435 16.2006 22.3435 16.2662 22.3435 16.3318C22.3435 17.7157 22.3236 19.1 22.3505 20.4833C22.3681 21.3886 21.9612 22.0092 21.2365 22.4611C20.6314 22.8382 19.9621 23.0391 19.272 23.172C18.121 23.3939 16.9571 23.4443 15.7898 23.3969C14.7469 23.355 13.7106 23.2481 12.7139 22.9038C12.0739 22.6826 11.4802 22.3819 11.0466 21.8303C10.7903 21.5043 10.6567 21.1299 10.6563 20.7105C10.6553 19.2535 10.656 17.7966 10.656 16.3396C10.656 16.2733 10.656 16.207 10.656 16.1383ZM11.7165 16.3893C11.7165 16.4647 11.7165 16.5205 11.7165 16.5763C11.7165 17.9257 11.7182 19.2755 11.7146 20.625C11.7139 20.7985 11.7651 20.9419 11.8751 21.0694C12.164 21.4039 12.5427 21.5976 12.939 21.7563C13.8094 22.1046 14.7206 22.244 15.6495 22.3038C16.7021 22.3715 17.7473 22.3292 18.7829 22.1263C19.505 21.9849 20.2072 21.7796 20.8229 21.3467C21.1251 21.1343 21.2983 20.8756 21.2913 20.466C21.269 19.1731 21.283 17.8794 21.283 16.5861C21.283 16.5249 21.283 16.4637 21.283 16.4042C21.2607 16.4001 21.2491 16.3944 21.2394 16.3967C19.8734 16.7187 18.5083 17.0464 17.1402 17.3599C16.8743 17.4208 16.589 17.4824 16.3254 17.4472C15.8583 17.3853 15.4002 17.2517 14.9391 17.1442C13.8722 16.8956 12.8057 16.6443 11.7165 16.3889V16.3893ZM23.94 14.2265C23.9387 13.9708 23.7761 13.7621 23.5121 13.6965C23.1225 13.5998 22.7308 13.5111 22.3402 13.4195C20.6317 13.0187 18.9235 12.6146 17.2137 12.2202C16.8656 12.1401 16.5305 12.0335 16.1472 12.1269C13.9503 12.6623 11.7465 13.1692 9.5456 13.687C9.22445 13.7628 9.05888 13.9528 9.06055 14.2339C9.06221 14.5129 9.2281 14.6979 9.55491 14.7747C11.7421 15.2901 13.929 15.8052 16.1173 16.3162C16.2812 16.3544 16.461 16.4052 16.619 16.3741C17.1642 16.2665 17.7024 16.1238 18.244 15.997C19.2304 15.766 20.2178 15.5373 21.2042 15.3067C21.9708 15.1274 22.7372 14.9478 23.5028 14.7645C23.7761 14.6993 23.9417 14.4889 23.9407 14.2258L23.94 14.2265Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4544 19.3784C23.4544 18.5903 23.4544 17.8019 23.4544 17.0137C23.4544 16.6688 23.6646 16.4237 23.9621 16.42C24.2672 16.4162 24.4843 16.6627 24.4843 17.0154C24.4843 18.6032 24.4846 20.1909 24.4843 21.7786C24.4843 22.1175 24.265 22.3649 23.9685 22.3643C23.6711 22.3636 23.4547 22.1178 23.4544 21.7769C23.4537 20.9773 23.4544 20.178 23.4544 19.3784Z",
    fill: "#252525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9395 24.9931C23.0182 24.3834 23.172 23.72 23.5753 23.1539C23.8235 22.8054 24.1049 22.8006 24.3651 23.138C24.6916 23.5617 24.8458 24.0702 24.947 24.5947C24.9909 24.821 25.0179 25.0652 24.9863 25.2907C24.9057 25.8672 24.4126 26.2607 23.8899 26.2053C23.3415 26.1475 22.9352 25.6635 22.9398 24.9931H22.9395Z",
    fill: "#252525"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1385_501",
    x: -30,
    y: -30,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1385_501"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1385_501",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1385_501",
    x1: 2.26667,
    y1: 2.26667,
    x2: 51.0398,
    y2: 64.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyStudyMaterials);
export default __webpack_public_path__ + "static/media/MyStudyMaterials.ead4fa23d7206752eb5cd29b93a85086.svg";
export { ForwardRef as ReactComponent };